import { Api } from 'src/apis/api';

interface ISessionProps {
  ip?: string;
  client: string;
  pageType: string;
  leadEmail?: string;
  campaignId: number;
  sessionId?: string;
  isCheckout?: boolean;
}

export const getSession = async ({
  ip,
  client,
  pageType,
  sessionId,
  leadEmail,
  campaignId,
  isCheckout = false,
}: ISessionProps) => {
  return await Api.importClick({
    client,
    pageType,
    campaignId,
    acceptHeader: '*/*',
    ipAddress: ip || '::1',
    requestUri: location.href,
    httpReferer: location.href,
    emailAddress: leadEmail || '',
    userAgent: navigator.userAgent,
    sessionId: isCheckout ? undefined : sessionId,
  });
};
